// Sürüm geçmişi + firma indirme kayıtları
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Download, History, Users } from 'lucide-react';
import { API, dt, fileSize, openFile } from './docLibShared';

export const DocHistory = ({ doc }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { axios.get(`${API}/doc-library/${doc.id}/downloads`).then(r => setRows(r.data)).catch(() => setRows([])); }, [doc.id, doc.download_count]);
  const firms = new Set((rows || []).map(r => r.company_id)).size;
  return (
    <div className="grid gap-4 md:grid-cols-2 border-t pt-3" data-testid={`doc-history-${doc.id}`}>
      <div className="space-y-2">
        <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500"><History className="h-3.5 w-3.5" />Sürümler ({doc.versions.length})</p>
        {[...doc.versions].reverse().map((v, i) => (
          <div key={v.id} className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm ${i === 0 ? 'border-emerald-200 bg-emerald-50/50' : 'bg-white'}`} data-testid={`doc-ver-${v.id}`}>
            <span className={`rounded px-1.5 py-0.5 text-xs font-bold ${i === 0 ? 'bg-emerald-600 text-white' : 'bg-slate-200 text-slate-700'}`}>v{v.version}</span>
            <span className="min-w-0 flex-1">
              <span className="block truncate font-medium text-slate-800">{v.name}</span>
              <span className="block text-xs text-slate-500">{dt(v.uploaded_at)} · {v.uploaded_by} · {fileSize(v.size)}{v.note ? ` · ${v.note}` : ''}</span>
            </span>
            <button type="button" className="rounded-md p-1.5 text-slate-500 hover:bg-slate-100" title="İndir" onClick={() => openFile(`${API}/doc-library/${doc.id}/versions/${v.id}/file`, v.name, true)} data-testid={`doc-ver-download-${v.id}`}><Download className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
      <div className="space-y-2">
        <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500"><Users className="h-3.5 w-3.5" />İndirmeler · {rows?.length || 0} kez, {firms} firma</p>
        <div className="max-h-56 overflow-y-auto rounded-lg border divide-y bg-white" data-testid={`doc-downloads-${doc.id}`}>
          {rows === null ? <p className="p-3 text-sm text-slate-400">Yükleniyor...</p>
            : rows.length === 0 ? <p className="p-3 text-sm text-slate-400">Henüz indiren firma yok.</p>
              : rows.map(r => (
                <div key={r.id} className="flex items-center gap-2 px-3 py-2 text-sm">
                  <span className="min-w-0 flex-1"><span className="block truncate font-medium text-slate-800">{r.company_name || '-'}</span><span className="text-xs text-slate-500">{r.user_name}</span></span>
                  <span className="rounded bg-slate-100 px-1.5 text-xs text-slate-600">v{r.version}</span>
                  <span className="text-xs text-slate-500">{dt(r.at)}</span>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};
